import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import templateId from '../../../libraries/lang-id';
import language from '../../../libraries/label-lang';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import {history} from '../../../shared/configure-store';
import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';
import Logo from '../../../images/logo.png';
import {bindActionCreators} from 'redux';
import {toast, ToastContainer} from 'react-toastify';
import AuthHelper from '../../../libraries/auth-helper';
import Copyright from '../../presentational/copyright';
import Api from '../../../libraries/api';
import _ from 'lodash';

require('dotenv').config();

SimpleReactValidator.addLocale('indo', templateId);

class Register extends Component {

    constructor(props) {

        super(props);

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

        this.state = {
            loading: false,
            showPassword: false,
            showPasswordConfirm: false,

            errors: {},
            email: '',
            firstName: '',
            lastName: '',
            phone: '',
            password: '',
            passwordConfirm: '',
            npwp: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.handleClickShowPasswordConfirm = this.handleClickShowPasswordConfirm.bind(this);
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Register';
    }

    componentWillReceiveProps() {

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };


    handleSubmit = e => {

        e.preventDefault();

        if (!this.validator.allValid()) {

            this.setState({
                    errors: this.validator.getErrorMessages()
                }
            );

            return false;

        }

        if (this.state.password !== this.state.passwordConfirm) {

            this.setState({
                    errors: {
                        password: 'Kata sandi harus sama',
                        passwordConfirm: 'Konfirmasi kata sandi harus sama',
                    }
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loading: true,
            }
        );

        let params = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            password: this.state.password,
            phone: this.state.phone,
            npwp: this.state.npwp,
        };

        Api.post('/register', params).then(resp => {
            this.setState({
                    loading: false,
                }
            );

            AuthHelper.setLoginReg(resp.data);

            AuthHelper.setProfile(resp.data);

            let profile = resp.data;

            let user = JSON.parse(JSON.stringify(profile));

            this.props.setProfile(user);

            history.push('/company');

        }).catch(err => {

            let errors = [];
            if(err.errors) {
                errors = err.errors;
                _.forEach(errors, function(v,k){
                    v = v[0];
                });
            }

            this.setState({
                    errors: errors,
                    loading: false
                }
            );

            this.showMessage(false, err.message);

        });

    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleClickShowPassword = () => {

        this.setState({

            showPassword:(!this.state.showPassword)

        });
    };

    handleClickShowPasswordConfirm = () => {

        this.setState({

            showPasswordConfirm:(!this.state.showPasswordConfirm)

        });
    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='login'>
                <section>
                    <div className='container position-relative'>
                        <div className='row align-items-end m-0 row-login'>
                            <div className='col-md-6 col-lg-7 px-lg-7 text-center text-md-left'>
                                <img src={Logo} alt='logo' className='img-logo' />
                            </div>
                            <div className='col-md-6 col-lg-5 px-lg-5 text-center'>
                                <p>{text.register_step}</p>
                                <h1>{text.register_heading}</h1>
                                <p>{text.register_have_account}? <Link to='/login'>{text.register_login}</Link>.</p>
                                <form name='register' id='register' noValidate>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='firstName'
                                            name='firstName'
                                            label={text.label_first_name}
                                            placeholder={text.label_first_name}
                                            onChange={(e) => this.handleChange(e, 'firstName')}
                                            value={this.state.firstName}
                                            fullWidth
                                        />
                                        {this.validator.message('firstName', this.state.firstName, 'required')}
                                        <div className='text-danger'>{this.state.errors.firstName}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='lastName'
                                            name='lastName'
                                            label={text.label_last_name}
                                            placeholder={text.label_last_name}
                                            onChange={(e) => this.handleChange(e, 'lastName')}
                                            value={this.state.lastName}
                                            fullWidth
                                        />
                                        {this.validator.message('lastName', this.state.lastName, 'required')}
                                        <div className='text-danger'>{this.state.errors.lastName}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='email'
                                            name='email'
                                            label={text.label_email}
                                            placeholder={text.label_email}
                                            onChange={(e) => this.handleChange(e, 'email')}
                                            value={this.state.email}
                                            fullWidth
                                        />
                                        {this.validator.message('email', this.state.email, 'email|required')}
                                        <div className='text-danger'>{this.state.errors.email}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='phone'
                                            name='phone'
                                            label={text.label_phone}
                                            placeholder={text.label_phone}
                                            onChange={(e) => this.handleChange(e, 'phone')}
                                            value={this.state.phone}
                                            fullWidth
                                        />
                                        {this.validator.message('phone', this.state.phone, 'numeric|required')}
                                        <div className='text-danger'>{this.state.errors.phone}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type={this.state.showPassword ? 'text' : 'password'}
                                            id='adornment-password'
                                            name='password'
                                            label={text.label_password}
                                            placeholder={text.label_password}
                                            onChange={(e) => this.handleChange(e,'password')}
                                            value={this.state.password}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <IconButton
                                                            aria-label='Toggle password visibility'
                                                            onClick={this.handleClickShowPassword}
                                                            className='pass'
                                                        >
                                                            {this.state.showPassword ? <i className='fas fa-eye'> </i> :
                                                                <i className='fas fa-eye-slash'> </i>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            fullWidth
                                        />
                                        {this.validator.message('password', this.state.password, 'required')}
                                        <div className='text-danger'>{this.state.errors.password}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type={this.state.showPasswordConfirm ? 'text' : 'password'}
                                            id='adornment-password'
                                            name='passwordConfirm'
                                            label={text.label_password_confirm}
                                            placeholder={text.label_password_confirm}
                                            onChange={(e) => this.handleChange(e,'passwordConfirm')}
                                            value={this.state.passwordConfirm}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <IconButton
                                                            aria-label='Toggle password visibility'
                                                            onClick={this.handleClickShowPasswordConfirm}
                                                            className='pass'
                                                        >
                                                            {this.state.showPasswordConfirm ? <i className='fas fa-eye'> </i> :
                                                                <i className='fas fa-eye-slash'> </i>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            fullWidth
                                        />
                                        {this.validator.message('passwordConfirm', this.state.passwordConfirm, 'required')}
                                        <div className='text-danger'>{this.state.errors.passwordConfirm}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='npwp'
                                            name='npwp'
                                            label='NPWP'
                                            placeholder='NPWP'
                                            onChange={(e) => this.handleChange(e, 'npwp')}
                                            value={this.state.npwp}
                                            fullWidth
                                        />
                                        <div className='text-left text-alert'>{this.state.errors.npwp}</div>
                                    </div>
                                    <div className='row align-items-center mt-3'>
                                        <div className='col-6 text-left'>
                                            {/*<Link to='/register' className='text-blue'>Buat Akun</Link>*/}
                                        </div>
                                        <div className='col-6'>
                                            <Button
                                                variant='contained'
                                                onClick={this.handleSubmit}
                                                color='primary'
                                                disabled={this.state.loading}
                                                className='full'
                                            >
                                                {text.button_next} { this.state.loading && <i className='fa fa-spinner fa-spin'> </i> }
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='col-12 mt-auto footer-float'>
                                <div className='row justify-content-end'>
                                    <div className='col-md-6 col-lg-5'>
                                        <footer>
                                            <p className='text-center d-none d-md-block'> <Copyright /></p>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <footer>
                    <p className='text-center d-md-none'> <Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        )
    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Register);